<template lang="pug">
.match-time
  template(v-if="isMore")
    template(v-if="source.runningTime == 'LIVE'")
      .live-group
        .live {{ $t("ui.live") }}
    template(v-else)
      span {{ source.runningTime }}
  template(v-else)
    //- small {{ source.marketId }}
    .dt-group(v-if="countDown > 0")
      .date {{ part1 }}
      .time {{ part2 }}
    .live-group(v-else)
      .live(v-if="source.marketId == 3") {{ $t("ui.live") }}
      .live-wrap
        .duration {{ part1 == 'LIVE' ? '' : part1 }}
        template(v-if="!isHideScore")
          .score {{ part2 }}
          //- .score(v-if="source.runningScore")
          //-   .scorebox {{ source.runningScore.split('-')[0] }}
          //-   .scorebox {{ source.runningScore.split('-')[1] }}
          //- .score(v-else)
          //-   .scorebox 0
          //-   .scorebox 0
//- div(:class="css")
//-   .match-info-wrapper
//-     template(v-if="countDown > 0")
//-       div(:class="part1css").blink
//-         small {{ part1 }}
//-     template(v-else)
//-       div(:class="part1css") {{ part1 }}
//-     .font-weight-bold.score {{ part2 }}
</template>

<script>
import config from "@/config";

export default {
  components: {},
  props: {
    mode: {
      type: Boolean,
      default: false
    },
    source: {
      type: Object
    },
    isMore: {
      type: Boolean,
      default: false
    },
    isHideScore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      countDown: 0,
      ticker: null
    };
  },
  computed: {
    currency_code() {
      return this.$store.getters.currencyCode;
    },
    css() {
      var mt = this.mode ? this.source.match[4] : this.source.marketId;
      var label = this.mode ? this.source.match[8] : this.source.runningTime;
      if (mt < 3) {
        return "match-info-date";
      } else {
        return label != null ? (label.trim().length > 0 ? "match-info-score" : "match-info-date") : "match-info-date";
      }
    },
    part1css() {
      var mt = this.mode ? this.source.match[4] : this.source.marketId;
      var label = this.mode ? this.source.match[7] : this.source.runningTime;
      if (mt < 3) {
        return "";
      } else {
        return label != null ? (label.trim().length > 0 ? "time" : "") : "";
      }
    },
    part1() {
      var offset = config.getCurrencyMinuteOffset(this.currency_code);
      var matchTime = this.mode ? this.source.match[8] : this.source.matchTime;
      var mdate = this.$dayjs(matchTime).subtract(offset, 'minute').format("MM/DD");
      var mtime = this.$dayjs(matchTime).subtract(offset, 'minute').format("HH:mm");

      var mt = this.mode ? this.source.match[4] : this.source.marketId;
      var label = this.mode ? this.source.match[12] : this.source.runningTime;
      if (mt < 3) {
        return mdate;
      } else {
        return label != null ? (label.trim().length > 0 ? this.getLabel(label) : mtime) : mtime;
      }
    },
    part2() {
      var offset = config.getCurrencyMinuteOffset(this.currency_code);
      var matchTime = this.mode ? this.source.match[8] : this.source.matchTime;
      var mdate = this.$dayjs(matchTime).subtract(offset, 'minute').format("MM/DD");
      var mtime = this.$dayjs(matchTime).subtract(offset, 'minute').format("HH:mm");

      var mt = this.mode ? this.source.match[4] : this.source.marketId;
      var score = this.mode ? this.source.match[11] : this.source.runningScore;
      var label = this.mode ? this.source.match[12] : this.source.runningTime;
      if (mt < 3) {
        return mtime;
      } else {
        if (label != null) {
          if (label.trim().length > 0) {
            return score != null ? (score.trim().length > 0 ? score.trim() : mdate) : mdate;
          } else {
            return mdate;
          }
        } else {
          return mdate;
        }
      }
    }
  },
  destroyed() {
    if (this.ticker) {
      clearTimeout(this.ticker);
    }
  },
  mounted() {
    if (this.source) {
      if (this.isEFight(this.source) && this.source.marketId == 3) {
        this.getCountDown();
      }
    }
  },
  methods: {
    isEFight(e) {
      if (e && e.sportsId) return config.vg1.includes(e.sportsId);
      else return false;
    },
    getCountDown() {
      this.ticker = setTimeout(() => {
        this.countDown = this.$dayjs(this.source.matchTime).add(10, "s").diff(this.$dayjs(), "s");
        if (this.countDown >= 0) {
          this.getCountDown();
        }
      }, 1000);
    },
    getStyle(e) {
      switch (e) {
        case "LIVE":
          return "danger";
          break;
        case "HT":
          return "info";
          break;
        case "DELAYED":
        case "PEN":
          return "warn";
          break;
        default:
          return "label";
          break;
      }
    },
    getLabel(e) {
      if (/\d/.test(e)) {
        return e.trim();
      } else {
        return this.$tc("m.BT_" + e.trim(), 1);
      }
    }
  }
};
</script>